import orderServices from "../../services/orders/orderservice";
import { DriverInfoDto } from "../../models/Delivery-Executive/DeliveryExecutive";

export const getDriversDetails = async (): Promise<DriverInfoDto[]> => {
  try {
    const res = await orderServices.getDriversDetails();
    const data = Array.isArray(res) ? res : res?.data;
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Error while fetching drivers details:", error);
    return [];
  }
};
